import React from 'react';
import { IconsPros } from '../icons/types';

/**
 * EmailIntegration Logo component
 *
 * @returns JSX.ELEMENT
 */
export const EmailIntegrationLogo = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 16 16" data-testid={dataTestId}>
      <path
        fill="#0098DB"
        d="M10.31,9l5.52-5.52A1,1,0,0,1,16,4v8a1,1,0,0,1-1,1h-.69Zm2.59,4L9.61,9.71,8.18,11.14a.25.25,0,0,1-.35,0L6.39,9.71,3.1,13ZM1,13h.69l4-4L.17,3.48A1,1,0,0,0,0,4v8A1,1,0,0,0,1,13ZM14.9,3H1.1L7.82,9.72a.25.25,0,0,0,.35,0Z"
      />
    </svg>
  );
};
